import { Component, Input } from '@angular/core';
import { CmTableColumn } from '../../models/table-column.class';

@Component({
    selector: 'cm-new-table-cell',
    templateUrl: './table-cell.component.html',
    styleUrls: ['./table-cell.component.scss'],
    standalone: false
})
export class CmTableCellComponent {
	@Input() col: CmTableColumn;
	@Input() element: any;

	constructor() {}
}
